export default "__VITE_ASSET__C7UERx2I__"